import React from 'react';

interface ModalProps {
  children: React.ReactNode;
  onClose: () => void;
  size?: 'sm' | 'md' | 'lg' | 'full';
  className?: string;
}

export const Modal: React.FC<ModalProps> = ({ 
  children, 
  onClose, 
  size = 'md',
  className = ''
}) => {
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const sizeClasses = {
    sm: 'max-w-md lg:max-w-lg min-w-sm lg:min-w-md',
    md: 'max-w-lg lg:max-w-xl min-w-md lg:min-w-lg',
    lg: 'max-w-2xl lg:max-w-3xl min-w-xl lg:min-w-2xl',
    full: 'max-w-full w-full h-full m-0 rounded-none',
  };

  return (
    <div 
      className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-start sm:items-center justify-center p-2 sm:p-4 md:p-6 overflow-y-auto"
      onClick={handleBackdropClick}
    >
      <div 
        style={{scrollbarWidth: 'thin', scrollbarColor: '#f59e0b transparent'}}
        className={`bg-neutral-600 rounded-lg sm:rounded-xl md:rounded-2xl shadow-2xl outline outline-1 outline-white/10 overflow-x-clip overflow-y-auto relative transform transition-all duration-300 ${sizeClasses[size]} ${className} max-h-full `}
      >
        {children}
      </div>
    </div>
  );
};